
/* global store */
/* global PLACEMENT_ID */
/* global IS_PREVIEW_PAGE */
/* global ENVIRONMENT */
import { getDwell } from 'Tracking/selectors';
import { fireTracking, fireThirdPartyTracking } from 'Tracking/index';
import { getClosest } from 'Tracking/utils';
import { callVPAID, vpaidPresent } from 'Renderer/utils/vpaid';


import {
  EXPAND,
  EXPAND_CLOSE,
  EXPAND_DWELL,
  SWITCH_ARTBOARD,
} from 'Tracking/constants/events';

import {
  AD_EVENT_DATA,
  AD_COMPONENT_TYPE,
  AD_DWELL_TIME,
  AD_COMPONENT_ID,
  AD_COMPONENT_NAME,
  AD_STATE,
} from 'Tracking/constants/trackingNames';

import {
  BUTTON,
} from 'Tracking/constants/componentTypes';

const type = { [AD_COMPONENT_TYPE]: BUTTON };

const validClickMacro = macro => ((macro.indexOf('http://') !== -1) || (macro.indexOf('https://') !== -1));

export const getButtonComponentInfo = (e) => {
  const componentId = e.target ? e.target.getAttribute('data-id') || null : null;
  const componentName = e.target ? e.target.getAttribute('data-name') || null : null;
  const componentContainer = e.target ? getClosest(e.target, 'div[data-artboard]') || null : null;
  const componentArtboard = componentContainer ? componentContainer.getAttribute('data-artboard') || null : null;
  return {
    [AD_COMPONENT_ID]: componentId,
    [AD_COMPONENT_NAME]: componentName,
    [AD_STATE]: componentArtboard,
  };
};

export const fireClickTrackingEvent = (e, eventName) => {
  const {
    ascm,
    ifrmascm,
    outstream,
    rootDocument,
    thirdPartyTracking,
    wallpaper,
  } = store.getState();
  const uid = (e.target && e.target.dataset) ? e.target.dataset.id : '';
  fireTracking(eventName, { ...type, ...getButtonComponentInfo(e) }, e.target);
  if (eventName === 'click-through') {
    e.preventDefault();
    const vpaid = vpaidPresent() ? callVPAID() : null;
    const sameWindow = frameElement && !outstream && !wallpaper;
    const targetDocument = sameWindow ? document : rootDocument;
    const virtualButton = targetDocument.createElement('a');
    const destinationUrl = e.target.dataset.href;
    const clickMacro = ascm || ifrmascm;
    const virtualButtonUrl = validClickMacro(clickMacro) ? `${clickMacro}${destinationUrl}` : destinationUrl;
    virtualButton.href = virtualButtonUrl;
    virtualButton.target = '_blank';
    if (vpaid) {
      vpaid.eventsCallbacks_.AdClickThru(virtualButtonUrl, uid, true);
      return;
    }
    if (ENVIRONMENT === 'dv360') {
      const dv360Url = `${window.clickTag}${destinationUrl}`;
      const clickthroughURL = validClickMacro(clickMacro) ? `${clickMacro}${dv360Url}` : dv360Url;
      window.clickTag = clickthroughURL;
      virtualButton.href = 'javascript:window.open(window.clickTag)';
      virtualButton.removeAttribute('target');
    }
    targetDocument.body.appendChild(virtualButton);
    virtualButton.click();
    targetDocument.body.removeChild(virtualButton);
    return;
  }
  if (thirdPartyTracking.clickevent && thirdPartyTracking.clickevent.all) fireThirdPartyTracking(thirdPartyTracking.clickevent.all);
  if (thirdPartyTracking.clickevent && thirdPartyTracking.clickevent[uid]) fireThirdPartyTracking(thirdPartyTracking.clickevent[uid]);
};

export const fireSwitchArtboardTrackingEvent = (e, artboardName) => {
  const encodedArtboardName = encodeURI(artboardName);
  fireTracking(SWITCH_ARTBOARD, { [AD_EVENT_DATA]: encodedArtboardName, ...type, ...getButtonComponentInfo(e) });
  store.dispatch({
    type: 'UPDATE_EXPAND_START_TIME',
    expandStartTime: new Date(),
  });
};

export const fireExpandTrackingEvent = (e) => {
  fireTracking(EXPAND, { ...type, ...getButtonComponentInfo(e) });
  store.dispatch({
    type: 'UPDATE_EXPAND_START_TIME',
    expandStartTime: new Date(),
  });
};

export const fireCloseExpandTrackingEvent = (e) => {
  const { expandStartTime } = store.getState();
  fireTracking(EXPAND_CLOSE, { ...type, ...getButtonComponentInfo(e) });
  fireTracking(EXPAND_DWELL, { ...type, [AD_DWELL_TIME]: getDwell(expandStartTime) });
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/tracking/actions/button.js